"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueCartDiscountTemplate = exports.uniqueCartTaxTemplate = void 0;
const uniqueCartTaxTemplate = (cartItem) => {
    return `${cartItem.percentage}_${cartItem.isTaxInclusive}`;
};
exports.uniqueCartTaxTemplate = uniqueCartTaxTemplate;
const uniqueCartDiscountTemplate = (discountItem) => {
    var _a, _b;
    const discountPercentage = (_a = `${discountItem.percentage}`) !== null && _a !== void 0 ? _a : '';
    return `${discountItem.discountId}_${(_b = discountItem.discount) === null || _b === void 0 ? void 0 : _b.type}_${discountPercentage}_${discountItem.actionId}`;
};
exports.uniqueCartDiscountTemplate = uniqueCartDiscountTemplate;
//# sourceMappingURL=cart.consts.js.map